if (!customElements.get('slider-dots')) {
  class SliderDots extends HTMLElement {
    constructor() {
      super();
      this.selector = {
        button: '.slider-bar',
        sliderComponent: 'slider-component',
        currentIndex: '.slider-counter--current',
        buttonNext: '.slider-button--next',
        buttonPrev: '.slider-button--prev',
        slide: '.slider__slide',
        sliderList: '.slider',
        sliderCounter: '.slider-counter--total'
      };
      this.lastKnownIndexText = 0;
      setTimeout(() => this.init(), 1000);
    }

    init() {
      const sliderComponent = this.closest('slider-component');
      if (!sliderComponent) return;

      this.currentIndexEl = sliderComponent.querySelector(this.selector.currentIndex);
      this.nextButton = sliderComponent.querySelector(this.selector.buttonNext);
      this.prevButton = sliderComponent.querySelector(this.selector.buttonPrev);
      this.buttons = this.querySelectorAll(this.selector.button);
      this.sliderComponent = sliderComponent;
      this.slides = this.sliderComponent.querySelectorAll(this.selector.slide);
      this.sliderList = this.sliderComponent.querySelector(this.selector.sliderList);
      this.totalEl = this.sliderComponent.querySelector(this.selector.sliderCounter);

      if (this.sliderComponent && this.slides && this.sliderList) {
        this.updateDotsVisibility();
      }

      this.buttons?.forEach((button, index) => {
        button?.addEventListener('click', () => {
          this.handleClick(button, index);
        });
      });

      // Listen for slide change events from the slider-component
      this.sliderComponent.addEventListener('slideChanged', (event) => {
        const currentPage = event.detail.currentPage;
        if (this.buttons[currentPage - 1]) {
          this.updateActiveButton(this.buttons[currentPage - 1]);
        }
        this.updateDotsVisibility();
      });

      window.addEventListener('resize', () => this.updateDotsVisibility());
    }

    handleClick(clickedButton, index) {
      const targetIndex = index; // 0-based index for slideScrollPosition calculation
      if (!this.sliderList || !this.slides[targetIndex]) return;

      const targetSlide = this.slides[targetIndex];
      const scrollLeft = targetSlide.offsetLeft;

      this.sliderList.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });

      this.updateActiveButton(clickedButton);
    }

    updateActiveButton(newActiveButton) {
      if (!newActiveButton) return;
      this.buttons.forEach(button => {
        button.classList.remove('active');
      });
      newActiveButton.classList.add('active');
    }



    updateDotsVisibility() {
      if (!this.sliderComponent || !this.buttons || !this.totalEl) return;

      const totalSlides = Number(this.totalEl.textContent) || 1;

      this.buttons.forEach((button, index) => {
        if (index < totalSlides) {
          button.classList.remove('hidden');
        } else {
          button.classList.add('hidden');
        }
      });
    }

  }

  customElements.define('slider-dots', SliderDots);
}